<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-descending-alphabet`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.558 42.553a1 1 0 00.442-.83V6a1 1 0 00-1-1h-2a1 1 0 00-1 1v25H4.17a.6.6 0 00-.487.95l7.326 10.176c.057.078.122.145.194.202l.037.047a1 1 0 001.317.178zM23.941 21H39.06c.482 0 .88-.363.935-.831l.006-.11v-1.876a.941.941 0 00-.831-.935l-.11-.006h-10.14l10.757-9.35a.941.941 0 00.317-.594L40 7.182v-1.24a.941.941 0 00-.831-.936L39.059 5H23.94a.941.941 0 00-.935.831l-.006.11V7.82c0 .482.363.88.831.935l.11.006h9.6l-10.217 8.871a.941.941 0 00-.317.595l-.007.116v1.717c0 .482.363.88.831.935l.11.006H39.06 23.94zM38.26 44h1.853a1 1 0 00.97-1.246l-.036-.112-6.88-18a1 1 0 00-.812-.634L33.232 24h-3.386c-.465.151-.763.338-.893.558l-.04.085-6.878 17.996a1 1 0 00.817 1.35l.117.007h1.837a1 1 0 00.886-.538l.05-.113 1.248-3.347h9.088l1.244 3.35a1 1 0 00.814.644l.124.007zm-3.667-8.002h-6.127l3.012-8.092h.094l3.02 8.092z"/></svg>
</template>
<script>

export default {
  name: 'IconDescendingAlphabet',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
